module.exports = __webpack_public_path__ + "./fonts/Spear_v06_SpearFill.f49d75c7593d6e6a59c35457c70cb037.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SpearGauge/images/Spear_v06_SpearFill.svg
// module id = ./src/components/SpearGauge/images/Spear_v06_SpearFill.svg
// module chunks = 0